import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ProductType } from '../../../_models/producttype';
import { AdminService } from '../../../_services/admin.service';
import * as FileSaver from 'file-saver';
import {ACLFeature} from '../../../_models/acl-feature';
import {Permissions} from '../../../_services/permissions';

@Component({
    selector: 'edit-csv-upload',
    styleUrls: ['upload.less'],
    templateUrl: 'upload.component.html',
})
export class UploadComponent implements OnInit, OnDestroy {

    @ViewChild('fileInput') fileInput;
    @ViewChild('driverFileInput') driverFileInput;

    @Input() driverGroups: Array<string>;
    @Input() driverType: string;

    iCanEditDrivers = false;
    iCanEditModules = false;
    iCanEditSensors = false;
    iCanEditSensorAccessories = false;
    iCanEditBridges = false;
    iCanDownloadCSVTemplate = false;

    uploadError = '';
    showUploadSuccessMessage = false;
    productType: ProductType = ProductType.create(1, 'module');
    importerSettings: Array<any> = [];

    productTypes: Array<ProductType> = [];

    constructor(
        private admin: AdminService,
        private permissions: Permissions
    ) {}

    ngOnInit() {

      this.permissions.hasFeature(ACLFeature.DOWNLOAD_CSV_TEMPLATE)
        .subscribe((success) => {
          this.iCanDownloadCSVTemplate = success;
        });

      this.permissions.hasFeature(ACLFeature.WRITE_MODULES)
        .subscribe((success) => {
          this.iCanEditModules = success;
          if (success) this.productTypes.push(ProductType.create(1, 'module'));
        });

      this.permissions.hasFeature(ACLFeature.WRITE_DRIVERS)
        .subscribe((success) => {
          this.iCanEditDrivers = success;
          if (success) this.productTypes.push(ProductType.create(2, 'driver'));
        });

      this.permissions.hasFeature(ACLFeature.WRITE_SENSORS)
        .subscribe((success) => {
            this.iCanEditSensors = success;
            if (success) {
                this.productTypes.push(ProductType.create(3, 'sensor'));
            }
        });

      this.permissions.hasFeature(ACLFeature.WRITE_SENSOR_ACCESSORIES)
        .subscribe((success) => {
            this.iCanEditSensorAccessories = success;
            if (success) {
                this.productTypes.push(ProductType.create(4, 'sensor accessory'));
            }
        });

      this.permissions.hasFeature(ACLFeature.WRITE_BRIDGES)
        .subscribe((success) => {
            this.iCanEditBridges = success;
            if (success) {
                this.productTypes.push(ProductType.create(5, 'bridge'));
            }
        });
    }

    templateDownload(productType: string) {
        this.admin.downloadCSVTemplate(productType).subscribe((res) => {
            //noinspection TypeScriptUnresolvedFunction
            FileSaver.saveAs(res, `${productType}.csv`);
        });
    }

    onProductTypeChange(event) {
        this.productType = event.updatedData;
    }

    onDriverTypeChange(event) {
        this.driverType = event.text;
    }

    fileSubmit() {
        this.uploadError = '';
        this.showUploadSuccessMessage = false;

        if (this.productType.name === 'driver' && (!this.driverType || this.driverType.length < 1)) {
            this.uploadError = 'Please choose a driver type!';
            return;
        }

        let importerSettings = this.importerSettings.map(s => s.id);
        let isett_ignoreUnknownProducts = importerSettings.includes("ignore_unknown_products");

        const fileElement = this.fileInput.nativeElement;
        if (fileElement.files && fileElement.files[0]) {
            const file = fileElement.files[0];
            const fileExtension = file.name.split('.').pop();
            if (fileExtension === 'csv') {
                this.admin.postCSVFile(file, this.productType.name, this.driverType, isett_ignoreUnknownProducts).subscribe(() => {
                    this.showUploadSuccessMessage = true;
                }, (error) => {
                    this.uploadError = JSON.parse(error._body).message;
                });
            } else {
                this.uploadError = 'Please provide a valid CSV file!';
            }
        } else {
            this.uploadError = 'Please provide a file!';
        }
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/management/components/csvupload/upload.component.ts